"use client";

import { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Globales from "utils/Globales";
import styles from "assets/jss/material-kit-pro-react/views/ecommerceSections/productsStyle.jsx";
import Categorias from "../../Generales/Controles/CategoriasTreeView.jsx";
import ModalTalla from "../ModalTalla.jsx";
import Accordion from "components/Accordion/Accordion.jsx";
import ModalImagen from "../ModalImagenProducto.jsx";
import { InfiniteLoader } from "components/InfiniteLoader/InfiniteLoader.jsx";
import { productsApi, urlMakePageFetcherProducts } from "../../../api/products";
import { makePageFetcher } from "../../../api/makePageFetcher";
import { ProductCardBase } from "components/ProductCardBase/ProductCardBase.jsx";
import { Grid } from "@material-ui/core";
import styled from "styled-components";
import "../../../Styles/GridStyle.css";
import { useDesingStore } from "stores/desingStore.js";

/**
 * Función para crear un fetchProducts con filtros dinámicos.
 * Los filtros se envían en un objeto "filters" que el backend puede extraer.
 *
 * Ejemplo de uso:
 * - Sin filtros: createFetchProducts() → solicitud normal
 * - Con filtros: createFetchProducts({ idCategoria: 123, precioMin: 100 })
 *
 * Formato de envío:
 * - POST: { filters: { idCategoria: 123 }, page: 1, pageSize: 10 }
 * - GET: ?filters={"idCategoria":123}&page=1&pageSize=10
 *   (el backend necesita hacer JSON.parse del query param "filters")
 *
 * @param {Object} filtros - Objeto con los filtros a aplicar
 *   (ej: { idCategoria: 123, precioMin: 100, precioMax: 500 })
 * @returns {Function} Función fetchPage compatible con InfiniteLoader
 */
const createFetchProducts = (filtros = {}) => {
	return makePageFetcher({
		url: urlMakePageFetcherProducts.url,
		method: urlMakePageFetcherProducts.method,
		staticPayload: filtros,
		dataPath: "items",
		totalPath: "totalRecords",
		pageField: "page",
		limitField: "pageSize",
		filtersKey: "filters",
		serializeFiltersAsJson: true,
	});
};

// Fetch inicial sin filtros
export const fetchProducts = createFetchProducts();

const StyledYellowP = styled.p`
	color: #ffcc66;
	font-size: 17px;
	font-weight: bold;

	@media (max-width: 992px) {
		text-align: center;
	}
	@media not (max-width: 992px) {
		text-align: end;
	}
	@media (max-width: 768px) {
		font-size: 15px;
		padding: 0 8px;
	}
	@media (max-width: 480px) {
		font-size: 14px;
		padding: 0 4px;
	}
`;

const StyledP = styled.p`
	color: white;
	font-size: 17px;

	@media (max-width: 992px) {
		text-align: center;
	}
	@media not (max-width: 992px) {
		text-align: end;
	}
	@media (max-width: 768px) {
		font-size: 14px;
		line-height: 1.4;
		padding: 0 8px;
	}
	@media (max-width: 480px) {
		font-size: 13px;
		padding: 0 4px;
	}
`;

const StyledTittleHome = styled.h2`
	color: white;
	font-size: 44px;
	font-weight: bold;
	line-height: normal;

	@media (max-width: 992px) {
		text-align: center;
	}
	@media (max-width: 768px) {
		font-size: 28px;
		line-height: 1.2;
		padding: 0 8px;
	}
	@media (max-width: 480px) {
		font-size: 22px;
		padding: 0 4px;
	}
`;

const useStyles = makeStyles(styles);

const SectionProducts = ({ id, setOverflowXStyle }) => {
	const {
		desingState,
		setDesingState,
		setDesing,
		clearDesing,
	} = useDesingStore();
	const classes = useStyles();
	const loaderRef = useRef(null);

	// Estados
	const [AcordionExpanded, setAcordionExpanded] = useState(true);
	const [VerModalTallas, setVerModalTallas] = useState(false);
	const [mostrarProductos, setMostrarProductos] = useState([]);
	const [ProductosTallas, setProductosTallas] = useState([]);
	const [ProductoSeleccionado, setProductoSeleccionado] = useState(null);
	const [CaracteristicasPorTalla, setCaracteristicasPorTalla] = useState([]);
	const [Tallas, setTallas] = useState([
		{ id: "1", Talla: "CH" },
		{ id: "2", Talla: "M" },
		{ id: "3", Talla: "G" },
	]);
	const [modalImagen, setModalImagen] = useState(false);
	const [currentPage, setCurrentPage] = useState(1);
	const [itemsPerPage] = useState(12);
	const [totalProductos, setTotalProductos] = useState(0);
	const [isFiltrado, setIsFiltrado] = useState(false);
	const [idCategoriaSeleccionada, setIdCategoriaSeleccionada] = useState("");
	const [Cargando, setCargando] = useState(true);
	const [fetchPageFunction, setFetchPageFunction] = useState(
		() => fetchProducts
	);
	const [infiniteLoaderKey, setInfiniteLoaderKey] = useState(0);
	const [categoriasKey, setCategoriasKey] = useState(0);

	// Efecto inicial (componentDidMount)
	useEffect(() => {
		clearDesing();
		document.body.style.backgroundColor = "#FFF";
		global.imagen = "";
		obtenerProductos(currentPage);
	}, []);

	// Efecto para cambios de página (componentDidUpdate)
	useEffect(() => {
		// Este efecto se ejecuta cuando currentPage cambia
		// Ya no es necesario porque handlePageChange maneja la lógica
	}, [currentPage]);

	const handlePageChange = (newPage) => {
		setCurrentPage(newPage);
		if (isFiltrado) {
			obtenerProductosPorCategoria(idCategoriaSeleccionada);
		} else {
			obtenerProductos(newPage);
		}
	};

	const ObtenerTallas = async (Producto, idCategoria, idAux, Productos) => {
		console.log({ Producto, idCategoria, idAux, Productos });

		// Con la nueva estructura, Productos es el producto master y tiene variaciones
		// idAux es el _id del producto master
		const idProductoMaster = idAux || Productos?._id;

		if (!idProductoMaster) {
			console.error("No se pudo obtener el ID del producto master");
			return;
		}

		try {
			const response = await productsApi.getVariationsByProductMaster(
				idProductoMaster
			);

			if (!response.error && response.data && response.data.length > 0) {
				const data = response.data[0];
				const tallasNuevas = [];
				const productosTallasNuevos = [];

				// Obtener tallas únicas del formato [[talla], [talla], ...]
				if (data.Tallas && Array.isArray(data.Tallas)) {
					data.Tallas.forEach((t) => {
						if (t && t[0]) {
							tallasNuevas.push(t[0]);
						}
					});
				}

				// Crear productosTallas desde las variaciones
				if (data.variaciones && Array.isArray(data.variaciones)) {
					data.variaciones.forEach((variacion) => {
						productosTallasNuevos.push({
							idProducto: variacion._id,
							Talla: variacion.Tamano,
							idDiseno: variacion._id,
						});
					});
				}

				setTallas(tallasNuevas);
				setProductosTallas(productosTallasNuevos);
				SeleccionarProducto(Producto, {
					...Productos,
					variaciones: data.variaciones || [],
				});
			} else {
				console.error(
					"Error al obtener variaciones:",
					response.mensaje || "Error desconocido"
				);
			}
		} catch (error) {
			console.error("Error al obtener variaciones:", error);
		}
	};

	const getProducts = async (pagina) => {
		const porPagina = itemsPerPage;
		try {
			const response = await productsApi.getProducts({
				pagina: pagina,
				porPagina: porPagina,
			});
			console.log(response);
			if (response.error) {
				// Error al obtener los registros
				setMostrarProductos([]);
			} else {
				// Obtuvo los registros correctamente
				setMostrarProductos(response.mensaje);
				setTotalProductos(response.totalRegistros);
			}
			setCargando(false);
		} catch (error) {
			setMostrarProductos([]);
			setCargando(false);
		}
	};

	const obtenerProductos = async (pagina) => {
		setCargando(true);
		const response = await productsApi.getProducts({ page: 1, pageSize: 8 });
		console.log(response);
		if (!response.success) {
			// Error al obtener los registros
			setMostrarProductos([]);
		} else {
			// Obtuvo los registros correctamente
			setMostrarProductos(response.data.items || []);
			setTotalProductos(response.data.totalRecords);
		}
		setCargando(false);
	};

	const obtenerProductosPorCategoria = (idCategoria) => {
		// Si no hay id, resetear a sin filtros
		if (!idCategoria || idCategoria === null || idCategoria === "") {
			setIsFiltrado(false);
			setIdCategoriaSeleccionada("");
			setFetchPageFunction(() => createFetchProducts());
			setInfiniteLoaderKey((prev) => prev + 1);
			return;
		}

		// Crear nuevo fetchPage con filtro de categoría
		const newFetchPage = createFetchProducts({ idCategoria: idCategoria });

		setIsFiltrado(true);
		setIdCategoriaSeleccionada(idCategoria);
		setFetchPageFunction(() => newFetchPage);
		setInfiniteLoaderKey((prev) => prev + 1);
	};

	const SeleccionarProducto = (Producto, Productos) => {
		setDesingState({
			Type: 1,
			Name: Producto.Nombre || Producto.NombreProducto || "",
			Description: Producto.Descripcion || "",
		});

		const caracteristicasPorTallaNuevas = [];

		// Con la nueva estructura, las variaciones vienen en Productos.variaciones
		const productosArray = Productos.variaciones || Productos.Producto || [];

		productosArray.forEach((m) => {
			caracteristicasPorTallaNuevas.push({
				idTalla: m.Tamano,
				caracteristicasAgregadas: m.caracteristicasAgregadas,
				atributosAgregados: m.atributosAgregados,
			});
		});
		setProductoSeleccionado(Producto);
		setCaracteristicasPorTalla(caracteristicasPorTallaNuevas);
		setVerModalTallas(true);
	};

	// Resetear solo el InfiniteLoader (sin tocar filtros)
	const resetLoader = () => {
		if (loaderRef.current) {
			loaderRef.current.reset();
		}
	};

	// Resetear filtros Y el InfiniteLoader
	const handleReset = () => {
		setIsFiltrado(false);
		setIdCategoriaSeleccionada("");
		setFetchPageFunction(() => fetchProducts);
		setInfiniteLoaderKey((prev) => prev + 1);
		setCategoriasKey((prev) => prev + 1);
	};

	// Resetear inteligente
	const reset = () => {
		if (isFiltrado || idCategoriaSeleccionada) {
			handleReset();
		} else {
			resetLoader();
		}
	};

	// Función para determinar si ImagenProducto es una URL o base64
	const getImageSrc = (imagenProducto) => {
		if (!imagenProducto) {
			return "/placeholder.svg";
		}

		// Verificar si es una URL (http:// o https://)
		if (
			typeof imagenProducto === "string" &&
			(imagenProducto.startsWith("http://") ||
				imagenProducto.startsWith("https://"))
		) {
			return imagenProducto;
		}

		// Si no es URL, asumir que es base64
		return "data:image/png;base64," + imagenProducto;
	};

	// Renderizado condicional del accordion
	let accordion;

	if (id === "SectionProducts") {
		accordion = (
			<GridContainer>
				<GridItem md={6} sm={12}>
					<StyledTittleHome>
						Selecciona tu prenda favorita y comienza a personalizar
					</StyledTittleHome>
				</GridItem>
				<GridItem md={6} sm={12} style={{ margin: "auto" }}>
					<StyledYellowP>
						Utiliza nuestra herramienta en línea para diseñar tu prenda
					</StyledYellowP>
					<StyledP>
						Con la mejor colección de arte, stickers y fuentes de la web,
						nuestra herramieta de diseño facilita la creación de prendas
						personalizadas que te encantarán
					</StyledP>
				</GridItem>
				<GridItem md={12} sm={12} style={{ margin: "auto" }}>
					<br />
					<br />
					<GridContainer>
						{mostrarProductos.map((producto, index) => {
							// Con la nueva estructura, producto es el master directamente
							// Obtener precio mínimo de las variaciones o usar el precio del master
							const precio =
								producto.variaciones && producto.variaciones.length > 0
									? Math.min(
											...producto.variaciones
												.map((v) => v.PrecioPublico || 0)
												.filter((p) => p > 0)
									  )
									: producto.PrecioPublico || 0;

							return (
								<GridItem key={index} md={3} sm={4} xs={6}>
									<center>
										<Card plain product>
											<CardHeader noShadow image>
												<div className="item">
													<a
														style={{ cursor: "pointer" }}
														onClick={() =>
															ObtenerTallas(
																producto,
																producto.idCategoria,
																producto._id,
																producto
															)
														}
													>
														<div style={{ display: "inline-flex" }}>
															<h4
																className={classes.cardTitle}
																style={{
																	color: `#FFCC66`,
																	cursor: "pointer",
																}}
															/>
														</div>
														<img
															width="auto"
															height="auto"
															src={getImageSrc(producto.ImagenProducto)}
															alt=".."
														/>
													</a>
												</div>
											</CardHeader>
											<CardBody plain style={{ padding: "10px" }}>
												<span
													className={classes.cardTitle}
													style={{
														float: "right",
														color: "#999",
														fontSize: "15px",
													}}
												>
													{new Intl.NumberFormat("es-MX", {
														style: "currency",
														currency: "MXN",
													}).format(precio)}
												</span>
												<a
													onClick={() =>
														ObtenerTallas(
															producto,
															producto.idCategoria,
															producto._id,
															producto
														)
													}
												>
													<p
														className={classes.cardTitle}
														style={{
															color: `#FFCC66`,
															cursor: "pointer",
															textAlign: "left",
															fontSize: "17px",
														}}
													>
														{producto.NombreProducto}&nbsp;
														<svg
															xmlns="http://www.w3.org/2000/svg"
															height="15"
															viewBox="0 0 512 512"
														>
															<path
																fill="white"
																d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160V416c0 53 43 96 96 96H352c53 0 96-43 96-96V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96z"
															/>
														</svg>
													</p>
												</a>
												<span
													className={classes.description}
													style={{ float: "left" }}
												>
													{producto.Descripcion}
												</span>
											</CardBody>
										</Card>
									</center>
								</GridItem>
							);
						})}
					</GridContainer>
				</GridItem>
			</GridContainer>
		);
	} else {
		accordion = (
			<GridContainer>
				<GridItem lg={3} md={12} sm={12}>
					<Accordion
						expanded={AcordionExpanded}
						onExpandChange={() => setAcordionExpanded(!AcordionExpanded)}
						activeColor="primary"
						collapses={[
							{
								title: "Categorías",
								content: (
									<Categorias
										key={categoriasKey}
										RegresarIdCategoria={obtenerProductosPorCategoria}
									/>
								),
							},
						]}
					/>
				</GridItem>
				<GridItem lg={9} md={12} sm={12}>
					<br />
					<br />
					<Grid container spacing={2}>
						<InfiniteLoader
							key={infiniteLoaderKey}
							fetchPage={fetchPageFunction}
							getItemKey={(item) => item.idProducto}
							pageSize={10}
							autoLoad
							autoLoadUntil={1}
							showLoadMoreButton
							emptyComponent={<div>No hay productos disponibles.</div>}
							renderItem={(item, idx) => (
								<Grid item lg={4} md={6} sm={6} xs={12}>
									<ProductCardBase
										product={item}
										classes={classes}
										onSelect={(Producto, idCategoria, idAux, Productos) =>
											ObtenerTallas(Producto, idCategoria, idAux, Productos)
										}
									/>
								</Grid>
							)}
						/>
					</Grid>
				</GridItem>
			</GridContainer>
		);
	}

	return (
		<div
			id={id === "SectionProducts" ? "SectionProducts" : undefined}
			className={id === "SectionProducts" ? `${classes.section} principal-section-products` : classes.section}
			style={id === "SectionProducts" ? { background: `black` } : {}}
		>
			<div className={classes.container}>
				{accordion}
				{/**Modales */}
				{VerModalTallas && (
					<ModalTalla
						EventoModalTalla={() => setVerModalTallas(false)}
						Tallas={Tallas}
						ProductosTallas={ProductosTallas}
						CaracteristicasPorTalla={CaracteristicasPorTalla}
						Producto={ProductoSeleccionado}
						VerModal={VerModalTallas}
					/>
				)}
				{modalImagen && (
					<ModalImagen
						EventoModalImagen={() => {
							setOverflowXStyle("hidden");
							setModalImagen(false);
						}}
						Producto={ProductoSeleccionado}
						VerModal={modalImagen}
					/>
				)}
			</div>
		</div>
	);
};

export default SectionProducts;
